export function ResponsiveRecordList({ children, className = '', testId = 'responsive-record-list' }) {
  return <div className={`space-y-3 ${className}`} data-testid={testId}>{children}</div>;
}

export function ResponsiveRecordCard({ accentColor, title, subtitle, badge, value, meta, actions, onOpen, testId, openTestId, leading }) {
  return (
    <div className="rounded-[1.5rem] border border-blue-100 bg-white p-4 shadow-sm transition-[transform,background-color,border-color] duration-150 hover:border-blue-200 hover:bg-blue-50/30 active:scale-[0.99] sm:rounded-md sm:border-zinc-200 sm:p-4" data-testid={testId}>
      <div className="flex gap-3">
        {leading && <div className="shrink-0 pt-0.5" data-testid={`${testId}-leading`}>{leading}</div>}
      <button type="button" className="min-h-14 min-w-0 flex-1 text-left" onClick={onOpen} data-testid={openTestId || `${testId}-open`}>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex min-w-0 gap-3">
            {accentColor && <div className="h-14 w-2 shrink-0 rounded-full sm:w-1" style={{ backgroundColor: accentColor }} />}
            <div className="min-w-0">
              <p className="text-lg font-black leading-tight text-zinc-900 sm:truncate sm:text-sm">{title}</p>
              {subtitle && <p className="mt-1 text-sm font-semibold leading-snug text-zinc-600 sm:truncate sm:text-xs sm:font-normal">{subtitle}</p>}
            </div>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-3">
            {value && <span className="rounded-2xl bg-emerald-50 px-3 py-1 text-base font-black text-emerald-700 sm:bg-transparent sm:p-0 sm:text-sm sm:text-zinc-900">{value}</span>}
            {badge}
          </div>
        </div>
      </button>
      </div>
      {(meta || actions) && (
        <div className="mt-3 flex flex-col gap-3 border-t border-blue-50 pt-3 text-sm font-semibold text-zinc-600 sm:flex-row sm:items-center sm:justify-between sm:border-zinc-100 sm:text-xs sm:font-normal" data-testid={`${testId}-meta`}>
          <div className="min-w-0">{meta}</div>
          <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">{actions}</div>
        </div>
      )}
    </div>
  );
}